//src/components/SellProperty.jsx
import React from "react";
import { HiArrowLeft, HiArrowRight } from "react-icons/hi";
import { MdCheckCircle } from "react-icons/md";
import { RiSendPlaneLine, RiVerifiedBadgeFill } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { SellPropertyProvider, useSellProperty } from "./SellPropertyContext";
import { ErrorAlert } from "./SellPropertyUI";
import { STEPS } from "./sellProperty.constants";
import Step0OwnerInfo from "./steps/Step0OwnerInfo";
import Step1PropertyDetail from "./steps/Step1PropertyDetail";
import Step2PriceSpecs from "./steps/Step2PriceSpecs";
import Step3Confirm from "./steps/Step3Confirm";

const STEP_COMPONENTS = [
  Step0OwnerInfo,
  Step1PropertyDetail,
  Step2PriceSpecs,
  Step3Confirm,
];

const SuccessScreen = ({ onReset }) => {
  const navigate = useNavigate();

  return (
    <div className="sell-success-page">
      <div className="sell-success-card">
        <div className="sell-success-icon">
          <MdCheckCircle size={40} color="var(--color-success)" />
        </div>

        <h2 className="sell-success-title">Properti Berhasil Diajukan!</h2>
        <p className="sell-success-desc">
          Listing properti Anda sedang ditinjau oleh tim kami. Kami akan
          menghubungi Anda via WhatsApp dalam 1×24 jam kerja.
        </p>

        <div className="sell-success-actions">
          <button className="btn-primary-mp" onClick={() => navigate("/")}>
            Kembali ke Beranda <HiArrowRight size={16} />
          </button>
          <button className="btn-outline-mp" onClick={onReset}>
            Ajukan Properti Lain
          </button>
        </div>
      </div>
    </div>
  );
};

const StepIndicator = ({ step }) => (
  <div className="sell-step-indicator">
    {STEPS.map((label, i) => (
      <React.Fragment key={i}>
        <div className={`sell-step${i === step ? " active" : i < step ? " done" : ""}`}>
          <div className="sell-step-circle">{i < step ? "✓" : i + 1}</div>
          <span className="sell-step-label">{label}</span>
        </div>

        {i < STEPS.length - 1 && (
          <div className={`sell-step-line${i < step ? " done" : ""}`} />
        )}
      </React.Fragment>
    ))}
  </div>
);

const SellPropertyInner = () => {
  const navigate = useNavigate();
  const {
    step,
    errors,
    loading,
    submitted,
    nextStep,
    prevStep,
    resetForm,
    handleSubmit,
  } = useSellProperty();

  if (submitted) return <SuccessScreen onReset={resetForm} />;

  const ActiveStep = STEP_COMPONENTS[step];
  const isLastStep = step === STEPS.length - 1;

  return (
    <div className="sell-page">
      <div className="sell-page-header">
        <div className="container sell-page-header-inner">
          <p className="sell-page-eyebrow">
            <RiVerifiedBadgeFill className="sell-page-eyebrow-icon" size={16} />
            <span>Platform Properti Terpercaya</span>
          </p>

          <h1 className="sell-page-title">Jual atau Sewakan Properti Anda</h1>
          <p className="sell-page-subtitle">
            Daftarkan properti Anda secara gratis dan jangkau ribuan calon
            pembeli &amp; penyewa aktif.
          </p>
        </div>
      </div>

      <div className="container sell-page-body">
        <StepIndicator step={step} />

        <div className="sell-form-card">
          <ErrorAlert message={errors.general} />
          <ActiveStep />

          <div className="sell-nav">
            <button
              type="button"
              className="sell-nav-back"
              onClick={step === 0 ? () => navigate(-1) : prevStep}
            >
              <HiArrowLeft size={16} />
              {step === 0 ? "Batal" : "Kembali"}
            </button>

            {!isLastStep ? (
              <button type="button" className="btn-primary-mp" onClick={nextStep}>
                Lanjut <HiArrowRight size={16} />
              </button>
            ) : (
              <button
                type="button"
                className="btn-primary-mp"
                onClick={handleSubmit}
                disabled={loading}
                style={{ opacity: loading ? 0.7 : 1 }}
              >
                {loading ? (
                  <>
                    <span className="sell-spinner" /> Mengirim...
                  </>
                ) : (
                  <>
                    <RiSendPlaneLine size={17} /> Kirim &amp; Ajukan Properti
                  </>
                )}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const SellProperty = () => (
  <SellPropertyProvider>
    <SellPropertyInner />
  </SellPropertyProvider>
);

export default SellProperty;
